export default __webpack_public_path__ + "static/media/trr-food-salad-chickencaesarsalad.7c4bbf9f.png";